var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1119.60911,
    height: 699,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "server down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m292.60911,426c-117.67956,0 -213,-95.32044 -213,-213c0,-117.67956 95.32044,-213 213,-213c117.67956,0 213,95.32044 213,213c0,117.67956 -95.32044,213 -213,213z",
    opacity: "undefined",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#3c4b64",
    d: "m0,51.14237c0,77.49789 48.6181,140.20819 108.70073,140.20819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#c5d0e2",
    d: "m108.70073,191.35056c0,-78.36865 54.255,-141.78356 121.30372,-141.78356"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#c5d0e2",
    d: "m39.38432,58.16768c0,73.61476 31.00285,133.18288 69.31641,133.18288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fill: "#3c4b64",
    d: "m108.70073,191.35056c0,-100.13772 62.7103,-181.16788 140.20819,-181.16788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#a8a8a8",
    d: "m85.8329,192.33905s15.41555,-0.47479 20.06141,-3.783s23.713,-7.2585 24.86553,-1.95278s23.16671,26.38821 5.76263,26.5286s-40.43935,-2.711 -45.07627,-5.53549s-5.6133,-15.25733 -5.6133,-15.25733z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    opacity: 0.2,
    d: "m136.83311,211.28489c-17.40408,0.14042 -40.43933,-2.71094 -45.07626,-5.53548c-3.53126,-2.151 -4.93843,-9.86945 -5.40926,-13.43043c-0.32607,0.014 -0.51463,0.02 -0.51463,0.02s0.97638,12.43276 5.61331,15.2573s27.67217,5.67589 45.07626,5.53547c5.02386,-0.04052 6.7592,-1.82793 6.66391,-4.47526c-0.69798,1.59951 -2.61404,2.59825 -6.35333,2.6284z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_8",
    fill: "#3c4b64",
    ry: 25.43993,
    rx: 187,
    cy: 424.5,
    cx: 198.60911
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_9",
    opacity: 0.1,
    ry: 21.35866,
    rx: 157,
    cy: 424.5,
    cx: 198.60911
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_10",
    fill: "#26303f",
    ry: 38.5,
    rx: 283,
    cy: 660.5,
    cx: 836.60911
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_11",
    fill: "#26303f",
    ry: 23.12721,
    rx: 170,
    cy: 645.5,
    cx: 310.60911
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    stroke: "#2f2e41",
    fill: "none",
    d: "m462.60911,626c90,23 263,-30 282,-90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    stroke: "#2f2e41",
    fill: "none",
    d: "m309.60911,259s130,-36 138,80s-107,149 -17,172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    stroke: "#2f2e41",
    fill: "none",
    d: "m184.01144,537.28332s39.0723,-10.82 41.47675,24.04449s-32.15951,44.78287 -5.10946,51.69566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    fill: "#3c4b64",
    d: "m778.70465,563.23988l-7.87754,50.29517s-38.78182,20.60284 -11.51335,21.20881s155.73324,0 155.73324,0s24.84461,0 -14.54318,-21.81478l-7.87756,-52.719l-113.92161,3.0298z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    opacity: 0.1,
    d: "m753.82817,634.19812c6.193,-5.51039 16.9989,-11.252 16.9989,-11.252l7.87756,-50.2952l113.9216,0.10717l7.87756,49.582c9.185,5.08711 14.8749,8.987 18.20362,11.97818c5.05882,-1.15422 10.58716,-5.44353 -18.20362,-21.38921l-7.87756,-52.719l-113.9216,3.02983l-7.87752,50.29517s-32.58815,17.31462 -16.99894,20.66306z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_17",
    fill: "#3c4b64",
    rx: 18.04568,
    height: 357.51989,
    width: 513.25314,
    y: 212.68859,
    x: 578.43291
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_18",
    fill: "#f2f2f2",
    height: 267.83694,
    width: 478.71308,
    y: 231.77652,
    x: 595.70294
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_19",
    fill: "#f2f2f2",
    r: 3.02983,
    cy: 223.29299,
    cx: 835.05948
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    fill: "#3c4b64",
    d: "m1091.68605,521.82226l0,31.34054a18.04341,18.04341 0 0 1 -18.04568,18.04568l-477.16177,0a18.04341,18.04341 0 0 1 -18.04569,-18.04568l0,-31.34054l513.25314,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_21",
    fill: "#3c4b64",
    points: "968.978 667.466 968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 651.452 645.651 962.312 645.651 968.978 667.466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    fill: "#3c4b64",
    d: "m1094.43711,661.53359c-0.59383,2.539 -2.83591,5.21743 -7.90178,7.75032c-18.179,9.08949 -55.1429,-2.42386 -55.1429,-2.42386s-28.4804,-4.84773 -28.4804,-17.573a22.72457,22.72457 0 0 1 2.49658,-1.48459c7.64294,-4.04351 32.98449,-14.02122 77.9177,0.42248a18.73921,18.73921 0 0 1 8.54106,5.59715c1.82082,2.13144 3.24843,4.83506 2.56974,7.7115z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    opacity: 0.1,
    d: "m1094.43711,661.53359c-22.251,8.526 -42.0843,9.1622 -62.43871,-4.975c-10.26507,-7.12617 -19.59089,-8.88955 -26.58979,-8.75618c7.64294,-4.04351 32.98449,-14.02122 77.9177,0.42248a18.73921,18.73921 0 0 1 8.54106,5.59715c1.82082,2.13149 3.24843,4.83511 2.56974,7.71155z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_24",
    fill: "#f2f2f2",
    ry: 2.42386,
    rx: 7.87756,
    cy: 654.13477,
    cx: 1066.53846
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_25",
    fill: "#f2f2f2",
    r: 11.51335,
    cy: 545.66686,
    cx: 835.05948
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "svg_26",
    opacity: 0.1,
    points: "968.978 667.466 968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 968.978 667.466"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_27",
    fill: "#26303f",
    height: 242,
    width: 208,
    y: 159,
    x: 108.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_28",
    fill: "#3c4b64",
    height: 86,
    width: 250,
    y: 135,
    x: 87.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_29",
    fill: "#3c4b64",
    height: 86,
    width: 250,
    y: 237,
    x: 87.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_30",
    fill: "#3c4b64",
    height: 86,
    width: 250,
    y: 339,
    x: 87.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_31",
    opacity: 0.4,
    fill: "#c5d0e2",
    height: 16,
    width: 16,
    y: 150,
    x: 271.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_32",
    opacity: 0.8,
    fill: "#c5d0e2",
    height: 16,
    width: 16,
    y: 150,
    x: 294.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_33",
    fill: "#c5d0e2",
    height: 16,
    width: 16,
    y: 150,
    x: 317.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_34",
    opacity: 0.4,
    fill: "#c5d0e2",
    height: 16,
    width: 16,
    y: 251,
    x: 271.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_35",
    opacity: 0.8,
    fill: "#c5d0e2",
    height: 16,
    width: 16,
    y: 251,
    x: 294.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_36",
    fill: "#c5d0e2",
    height: 16,
    width: 16,
    y: 251,
    x: 317.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_37",
    opacity: 0.4,
    fill: "#c5d0e2",
    height: 16,
    width: 16,
    y: 352,
    x: 271.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_38",
    opacity: 0.8,
    fill: "#c5d0e2",
    height: 16,
    width: 16,
    y: 352,
    x: 294.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_39",
    fill: "#c5d0e2",
    height: 16,
    width: 16,
    y: 352,
    x: 317.60911
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_40",
    fill: "#3c4b64",
    r: 79,
    cy: 538,
    cx: 316.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_41",
    fill: "#3c4b64",
    height: 43,
    width: 24,
    y: 600,
    x: 280.60911
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_42",
    fill: "#3c4b64",
    height: 43,
    width: 24,
    y: 600,
    x: 328.60911
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_43",
    fill: "#3c4b64",
    ry: 7.5,
    rx: 20,
    cy: 643.5,
    cx: 300.60911
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_44",
    fill: "#3c4b64",
    ry: 7.5,
    rx: 20,
    cy: 642.5,
    cx: 348.60911
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_45",
    fill: "#fff",
    r: 27,
    cy: 518,
    cx: 318.60911
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_46",
    fill: "#3f3d56",
    r: 9,
    cy: 518,
    cx: 318.60911
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_47",
    fill: "#c5d0e2",
    d: "m239.97644,464.53228c-6.37889,-28.56758 14.01185,-57.43392 45.544,-64.47477s62.2651,10.41 68.644,38.9776s-14.51861,39.10379 -46.05075,46.14464s-61.75836,7.92011 -68.13725,-20.64747z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-23.1712 400 500)",
    id: "svg_48",
    fill: "#3c4b64",
    ry: 12.40027,
    rx: 39.5,
    cy: 500,
    cx: 400
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-23 230 570.029)",
    stroke: "null",
    id: "svg_49",
    fill: "#3c4b64",
    ry: 12,
    rx: 40,
    cy: 570.02916,
    cx: 230
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_50",
    fill: "#fff",
    d: "m362.60911,561c0,7.732 -19.90861,23 -42,23s-43,-14.268 -43,-22s20.90861,-6 43,-6s42,-2.732 42,5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.dc59e5e1fec09e180005ca280abc7de6.svg";
export { ForwardRef as ReactComponent };